module.exports = __webpack_public_path__ + "img/ics_f_info_circle_gray.fb0c22e9.svg";